import './task-btn.scss'
import { ReactNode } from 'react'

interface TaskBtnProps {
  onClick?: () => void
  children: ReactNode
  /** 1 | 2 | 3 */
  type: number
}

export default function TaskBtn(props: TaskBtnProps) {
  const { children, type, onClick } = Object.assign({ children: null }, props)

  const handleClick = () => {
    onClick instanceof Function && onClick()
  }

  return (
    <div className={`task-btn btn${type}`} onClick={handleClick}>
      <p>
        <span>{children}</span>
        <span>{children}</span>
      </p>
    </div>
  )
}
